import React from "react";

import { mdiLandPlots } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";

import { TypeEnum } from "@/src/api/ProjectAPI.types";

import { MENU_ICON_SIZE } from "./Menu";
import MenuItem from "./MenuItem";
import SubMenu from "./SubMenu";
import useAbility from "../../hooks/useAbility";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function PlatformSubMenu(): JSX.Element {
  const { t } = useTranslation("editor-menu");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { canAccess } = useAbility();

  const orgaConfig = useSelector(
    (state: AppState) => state.fetchReducer.orga_config,
  );

  const currentProject = useSelector(
    (state: AppState) => state.architectureReducer.project,
  );

  const isEDU = currentProject?.type === TypeEnum.Edu;

  const { project: canAccessProject } = canAccess(
    orgaConfig.data?.organization_options,
  );

  return (
    <SubMenu
      icon={<Icon path={mdiLandPlots} size={MENU_ICON_SIZE} />}
      label={t("platform")}
    >
      {canAccessProject.layout ? (
        <MenuItem
          component={<NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/layout`} />}
          label={t("platform_display")}
        />
      ) : null}
      {canAccessProject.configuration && !isEDU ? (
        <MenuItem
          label={t("configuration")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/configuration`} />
          }
        />
      ) : null}
      {canAccessProject.layout ? (
        <MenuItem
          label={t("appearance")}
          component={
            <NavLink to={`${PROJECTS_ROUTE}/${projectSlug}/appearance`} />
          }
        />
      ) : null}
    </SubMenu>
  );
}

export default PlatformSubMenu;
